const has = value => {
  return typeof value !== "undefined"
}

export const mapValues = (props, isVariation) => {
  return (
    props &&
    `
   ${has(props.x) ? `--ft-x: ${pickVariation(props.x, isVariation)};` : ""}
   ${has(props.y) ? `--ft-y: ${pickVariation(props.y, isVariation)};` : ""}
   ${has(props.mb) ? `--ft-mb: ${pickVariation(props.mb, isVariation)};` : ""}
   ${has(props.mt) ? `--ft-mt: ${pickVariation(props.mt, isVariation)};` : ""}
   ${has(props.w) ? `--ft-w: ${pickVariation(props.w, isVariation)};` : ""}
   ${has(props.z) ? `--ft-z: ${pickVariation(props.z, isVariation)};` : ""}
  `
  )
}

export const pickVariation = (value, isVariation) => {
  if (Array.isArray(value)) {
    return value[isVariation ? 0 : 1]
  }
  return value
}

export const cycleStyles = (styles, index, isVariation) => {
  return mapValues(styles[index % styles.length], isVariation)
}
